/** RFC 0345 3h. No core import: this runs in entry, before wasm is ready. */
const PENDING = 'mod_sharing_pending_invite'

/** The invite link carries its secret in the fragment. Keep it in this tab
 * across sign-in, which returns to /w and would drop the fragment. */
export function stashInviteFromUrl(location: Location = window.location) {
  // The Share panel's link is /invite/<id>; /w/invite/<id> is the older form.
  // Matching only the older one dropped every invite without a word.
  const id = location.pathname.match(/^\/(?:w\/)?invite\/([0-9a-f]{32})$/)?.[1]
  const secret = new URLSearchParams(location.hash.slice(1)).get('k')
  if (!id || !secret) return false
  sessionStorage.setItem(PENDING, JSON.stringify({ id, secret }))
  history.replaceState(null, '', '/w')
  return true
}

export function pendingInvite(): { id: string; secret: string } | undefined {
  try {
    const value = JSON.parse(sessionStorage.getItem(PENDING) ?? 'null')
    return value?.id && value?.secret ? value : undefined
  } catch {
    return undefined
  }
}

export function clearPendingInvite() {
  sessionStorage.removeItem(PENDING)
}
